import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ChartLoader from '../../Loaders/ChartLoader';
import axios from '../../../utils/axiosClient';

import { chartRed, chartYellow } from '../../../shared/config';
import Auth from '../../../shared/Auth';
import CustomLineChart from '../../Custom/CustomLineChart';

const initChartObj = {
  title: 'Reactive (Import & Export) Energy Profile',
  unit: 'Energy ( - )',
  series: [
    {
      name: 'activeImpCumEng',
      color: chartRed,
      data: [],
    },
    {
      name: 'activeExpCumEng',
      color: chartYellow,
      data: [],
    },
  ],
};

class ReactiveImpExpEnergy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialize: true,
      options: {},
      chartObj: null,
    };
    this.chart = null;
  }

  componentDidMount() {
    this.fetchData(this.props.assetId, 1);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.assetId, nextProps.assetId)) {
      this.fetchData(nextProps.assetId, 1);
    }
  }

  async fetchData(assetId, noOfMonths) {
    // noOfMonths = 1 or 0 1 - 1month,0 - 6month
    this.setState({ initialize: true });

    const self = this;
    const checkToken = await Auth();
    if (checkToken) {
      const url = `report/reactiveimpexpenergybyassetid/${assetId}/${noOfMonths}`;
      axios
        .get(url) // 1 for 1 month data load
        .then((response) => {
          if (response.data.statusCode === 200) {
            const ActiveImpCumEng = [];

            let unit = '';
            const { result } = response.data;
            if (result.length) {
              unit = result[0][0].EnergyUnit;
              const ValuesToPush = _.tail(_.keys(result[1][0]));
              _.map(ValuesToPush, () => ActiveImpCumEng.push([]));
              _.map(result[1], (item) => {
                const tmstmp = Date.parse(item.RptDateTime.replace('_', ' '));
                _.map(ValuesToPush, (ele, index) =>
                  ActiveImpCumEng[index].push([tmstmp, parseFloat(item[ele])])
                );
              });

              const seriesArr = _.map(ValuesToPush, (item, index) => ({
                name: item,
                data: ActiveImpCumEng[index],
              }));

              const chartObj = {
                title: 'Reactive (Import & Export) Energy Profile',
                unit: `Energy (${unit})`,
                selected: noOfMonths === 1 ? 0 : 3,
                series: seriesArr,
                evnt: () => self.fetchData(assetId, 6),
              };

              this.setState({
                chartObj,
                initialize: false,
              });
            }
          } else {
            this.setState({ chartObj: initChartObj, initialize: false });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ chartObj: initChartObj, initialize: false });
        });
    }
  }

  render() {
    const { initialize, chartObj } = this.state;
    return initialize ? (
      <ChartLoader height="150" width="600" />
    ) : (
      <CustomLineChart options={chartObj} />
    );
  }
}

ReactiveImpExpEnergy.propTypes = {
  assetId: PropTypes.number.isRequired,
};
export default ReactiveImpExpEnergy;
